"use client";

import { useRef, useState } from "react";
import { ImageProps } from "./MediaItem";

type MediaItemImageProps = {
  imageProps: ImageProps;
  objectFit: "cover" | "contain";
  fetchPriority: "auto" | "high" | "low" | undefined;
  lqip?: string;
};

export const MediaItemImage = ({
  imageProps,
  objectFit,
  fetchPriority,
  lqip,
}: MediaItemImageProps) => {
  const [load, setLoad] = useState(false);
  const imgRef = useRef<HTMLImageElement | null>(null);

  return (
    /* wrong typed I guess because alt is inside rest */
    /* component is used inside <picture> tag */
    /* eslint-disable-next-line jsx-a11y/alt-text, @next/next/no-img-element */
    <img
      {...(imageProps ?? {})}
      style={{
        ...(imageProps?.style ?? {}),
        width: "100%",
        height: "100%",
        objectFit,
        ...(lqip &&
          !load && {
            backgroundImage: lqip,
            backgroundSize: objectFit,
            backgroundPosition: "50% 50%",
            backgroundRepeat: "no-repeat",
          }),
      }}
      ref={(img) => {
        if (img && !imgRef.current) {
          imgRef.current = img;
          if (img.complete) {
            const p = "decode" in img ? img.decode() : Promise.resolve();
            p.catch(() => {}).then(() => {
              if (img.isConnected) setLoad(true);
            });
          }
        }
      }}
      onLoad={(e) => {
        const img = e.currentTarget;
        const p = "decode" in img ? img.decode() : Promise.resolve();
        p.catch(() => {}).then(() => {
          if (img.isConnected) setLoad(true);
        });
      }}
      {...(fetchPriority && { fetchpriority: fetchPriority })}
    />
  );
};
